export const EXTEND_CARD_PURCHASE_REQUEST = `
  mutation extendCardPurchase($input: ExtendCardPurchaseInput!) {
    extendCardPurchase(input: $input) {
      id
      status
      message
    }
  }
 `

export const NEW_CARD_PURCHASE_REQUEST = `
  mutation newCardPurchase($input: NewCardPurchaseInput!) {
    newCardPurchase(input: $input) {
      id
      status
      message
    }
  }

`
export const NEW_CARD_PURCHASE_AND_REGISTER_REQUEST = `
  mutation newPurchaseAndRegister($input: NewCardPurchaseInput!) {
    newPurchaseAndRegister(input: $input) {
      id
      status
      message
    }
  }
`

export const CREATE_CHECKOUT_SESSION_REQUEST = `
  mutation createCheckoutSession($input: CreateCheckoutSessionInput!) {
    createCheckoutSession(input: $input) {
      statusCode
      url
    }
  }
`
